import React, { PropTypes } from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const ProfileMeta = ({ username, avatar }) => {
  const profileTitle = `${username}'s profile on crowdspring`;
  const canonicalURL = getCanonicalURL(`/users/${username}/`);
  /* avatar or the default */
  const profilePic = avatar && avatar.length > 0 ? avatar : 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_fb-share.png';

  const meta = [
    { name: "robots", content: "noindex,follow" },
    { property: 'og:title', content: profileTitle },
    { property: 'og:url', content: canonicalURL },
    { property: 'og:image', content: profilePic },
  ];

  const links = [
    { rel: "canonical", href: canonicalURL }
  ];

  return (<Meta title={profileTitle} link={links} meta={meta} />);
};

ProfileMeta.propTypes = {
  username: PropTypes.string,
};

const PortfolioMeta = ({ username, avatar, portfolio_thumbnail_1 }) => {
  const portfolioTitle = `${username}'s portfolio on crowdspring`;
  const canonicalURL = getCanonicalURL(`/users/${username}/portfolio/`);
  /* first thumbnail or avatar or the default */
  const portfolioPic = portfolio_thumbnail_1 && portfolio_thumbnail_1.length > 0 ? portfolio_thumbnail_1 : (avatar && avatar.length > 0 ? avatar : 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_fb-share.png');

  const meta = [
    { name: "robots", content: "noindex,follow" },
    { property: 'og:title', content: portfolioTitle },
    { property: 'og:url', content: canonicalURL },
    { property: 'og:image', content: portfolioPic },
  ];

  const links = [
    { rel: "canonical", href: canonicalURL }
  ];

  return (<Meta title={portfolioTitle} link={links} meta={meta} />);
};

export { ProfileMeta, PortfolioMeta }



// WEBPACK FOOTER //
// ./profile/components/meta.jsx